// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import {
  API2_HOST as _API2_HOST,
  DOMAIN,
  DOMAIN_TYPE,
  TOKEN_COOKIE_KEY,
} from '@bfe/by-dynamic-domain';
import { isProdOrTestnet, protocol, repaired_hostname } from '@bfe/by-env';

const devEnvApiHost = () => {
  const envReg = /^(www|m)$/;
  let env = 'public-test-1';
  let domain = 'bybit';
  let domainType = 'com';
  let domainTypeLocale = '';

  if (process.env.NODE_ENV !== 'production') {
    const hostSplits = repaired_hostname ? repaired_hostname.split('.') : [];

    if (hostSplits.length === 3) {
      // www.bybit.com
      // testnet.bybit.com
      // m.bybit.com
      // m-testnet.bybit.com
      const _hostSplits = _slicedToArray(hostSplits, 3);

      env = _hostSplits[0];
      domain = _hostSplits[1];
      domainType = _hostSplits[2];
    }

    if (hostSplits.length === 4) {
      if (isProdOrTestnet) {
        // www.bybit.com.hk
        const _hostSplits2 = _slicedToArray(hostSplits, 4);

        env = _hostSplits2[0];
        domain = _hostSplits2[1];
        domainType = _hostSplits2[2];
        domainTypeLocale = _hostSplits2[3];
        domainType = ''.concat(domainType, '.').concat(domainTypeLocale);
      } else {
        // www.cht-test-1.bybit.com
        const _hostSplits3 = _slicedToArray(hostSplits, 4);

        env = _hostSplits3[1];
        domain = _hostSplits3[2];
        domainType = _hostSplits3[3];
      }
    } // www.cht-test-1.bybit.com.hk

    if (hostSplits.length === 5) {
      const _hostSplits4 = _slicedToArray(hostSplits, 5);

      env = _hostSplits4[1];
      domain = _hostSplits4[2];
      domainType = _hostSplits4[3];
      domainTypeLocale = _hostSplits4[4];
      domainType = ''.concat(domainType, '.').concat(domainTypeLocale);
    }

    const api2ServicePrefix = 'api2.'.concat(
      !envReg.test(env) ? ''.concat(env, '.') : '',
    );

    console.log('protocol', hostSplits.length, _slicedToArray(hostSplits, 4));
    return ''
      .concat(protocol, '//')
      .concat(api2ServicePrefix)
      .concat(domain, '.')
      .concat(domainType);
  }
  return null;
};

const API2_HOST = devEnvApiHost() || _API2_HOST;

export { API2_HOST, DOMAIN, DOMAIN_TYPE, TOKEN_COOKIE_KEY };
